// src/directives/trimEmail.js
export default {
	mounted(el) {
		applyLowercase(el)
	},
	updated(el) {
		applyLowercase(el)
	},
}

function applyLowercase(el) {
	const input = el.tagName === 'INPUT' ? el : el.querySelector('input')
	if (!input) return
    
    input.addEventListener('input', () => {
        const lower = input.value.toLowerCase()
        if (input.value !== lower) {
            input.value = lower
            input.dispatchEvent(new Event('input'))
        }
	})

	input.addEventListener('blur', () => {
		input.value = input.value.toLowerCase()
        input.dispatchEvent(new Event('input'))
	})
}
